import { FC } from "react";

import "./ClientListSkeleton.scss";

const ClientListSkeleton: FC = () => {
  return (
    <div className="client-list-skelton" aria-hidden="true">
      <div className="details">
        <div className="motif-skeleton-circle circle"></div>
        <div className="name">
          <h4 className="motif-skeleton-6"></h4>
          <span className="motif-skeleton-12"></span>
        </div>
      </div>
      <div className="motif-skeleton-1 button-loader"></div>
    </div>
  );
};

export default ClientListSkeleton;
